import { render, staticRenderFns } from "./CoverageGaps.vue?vue&type=template&id=d21f1acc&lang=pug"
import script from "./CoverageGaps.vue?vue&type=script&lang=js"
export * from "./CoverageGaps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports